import { Pipe, PipeTransform } from '@angular/core';
import { GridColumn, GridOption, GridItem } from '../grid-control.model';
@Pipe({
  name: 'editorHandler'
})
export class EditorHandlerPipe implements PipeTransform {
  transform(value: any, item: GridItem, gridOption: GridOption): boolean {
    const visible = (column: GridColumn) => {
      if (column.type === 'children') {
        return false;
      }
      let isDisabled = false;

      // Kiểm tra xem có bị disabled hay không?
      if (column.editor) {
        isDisabled = typeof (column.editor.disabled) === 'function' ? column.editor.disabled(item) : column.editor.disabled;
      }
      // Nếu bị disabled return false
      if (isDisabled) {
        return false;
      }

      if (typeof (gridOption.editor?.disabled) === 'function') {
        isDisabled = gridOption.editor.disabled(item);
      } else {
        isDisabled = gridOption.editor?.disabled;
      }
      // Nếu bị disabled return false
      if (isDisabled) {
        return false;
      }

      // Hiển thị editor nếu dòng đó:
      // Đang được edit: editingStatus
      return item.editingStatus
        // Được thiết lập alwayDisplay
        || column.editor?.alwayDisplay
        // Editable có thuộc tính type inline
        || gridOption.editor?.type === 'inline';
    };
    item.editorHandler = item.editorHandler || {};
    for (const column of gridOption.columns) {
      item.editorHandler.disabled = false;
      item.editorHandler[column.field] = {};
      if (typeof (gridOption.editor) === 'object') {
        if (typeof (gridOption.editor.disabled) === 'function') {
          item.editorHandler.disabled = gridOption.editor.disabled(item);
        } else {
          item.editorHandler.disabled = gridOption.editor.disabled;
        }
      } else {
        item.editorHandler.disabled = false;
      }

      if (item.editorHandler.disabled) {
        item.editorHandler[column.field].visible = false;
      } else {
        item.editorHandler[column.field].visible = visible(column);
      }
    }
    return true;
  }
}
